import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { IDataInput, ITreeNode } from '../../../interface/interfaces';

interface IInitialState {
    projectDetailsLoading: boolean;
    projectDetailsData: ITreeNode[];
    projectDetailsError: string;
}

const initialState: IInitialState = {
    projectDetailsLoading: false,
    projectDetailsData: [],
    projectDetailsError: '',
};

const treeSlice = createSlice({
    name: 'projectDetails',
    initialState,
    reducers: {
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        projectDetailsPending: (state: IInitialState, action: PayloadAction<IDataInput>) => {
            state.projectDetailsLoading = true;
            state.projectDetailsError = '';
        },

        projectDetailsFulfilled: (state: IInitialState, action: PayloadAction<ITreeNode[]>) => {
            state.projectDetailsLoading = false;
            state.projectDetailsData = action.payload;
            state.projectDetailsError = '';
        },

        projectDetailsFailure: (state: IInitialState, action: PayloadAction<string>) => {
            state.projectDetailsLoading = false;
            state.projectDetailsData = [];
            state.projectDetailsError = action.payload;
        },
    },
});

export default treeSlice.reducer;
export const { projectDetailsPending, projectDetailsFulfilled, projectDetailsFailure } = treeSlice.actions;
